(ns renolit-roofing-service.layout.form.form-item.checkbox
  (:require [goog.object :as g]
            [re-frame.core :as rf]
            [renolit-roofing-service.layout.advanced-tooltip :as layout.advanced-tooltip]
            [renolit-roofing-service.layout.form.error :as form.error]
            [renolit-roofing-service.layout.form.form-item :as form.form-item]
            [renolit-roofing-service.localization :refer [t]]))

(defn- make-on-change-handler
  [opts]
  (fn [e]
    (let [new-value (g/getValueByKeys e "currentTarget" "checked")]
      (form.form-item/on-change-event-handler opts :on-change new-value))))

(defn- label-with-tooltip [component-id label-transl-kw label info-tooltip-transl-kw
                           css-class-prefix disabled? mandatory? form-errors]
  [:div.form-item__label-with-tooltip
   [:label.form-item__label
    (cond-> {:for component-id}
      css-class-prefix
      (assoc :class (str css-class-prefix "__label")))
    (str (or (t [label-transl-kw]) label) (when mandatory? " *"))]
   (when (and (not (boolean disabled?)) info-tooltip-transl-kw)
     [:f> layout.advanced-tooltip/advanced-tooltip
      {:reference {:component form.form-item/info-tooltip-reference}
       :floating {:component form.form-item/info-tooltip-floating
                  :args {:transl-kw info-tooltip-transl-kw}}}
      (when (seq @form-errors) [form.error/form-item-errors @form-errors])])])

(defmethod form.form-item/form-item-component :checkbox
  [{:keys [context path] :as _opts}]
  (let [component-id (str (random-uuid))
        form-errors (rf/subscribe [::form.error/errors context path])]
    (fn [{:keys [state path subscription-parameters disabled?
                 label-transl-kw label info-tooltip-transl-kw
                 css-class-prefix mandatory? full-line?]
          :or {disabled? false}
          :as opts}]
      [:div.form-item.form-item--checkbox
       {:class [(when disabled? "form-item--disabled")
                (when full-line? "form-item--full-line")
                (when css-class-prefix css-class-prefix)]}
       [:input.form-item__checkbox
        (cond-> {:id component-id
                 :type "checkbox"
                 :disabled disabled?
                 :checked (if state
                            (get-in @state path)
                            (when subscription-parameters @(rf/subscribe (vec (into subscription-parameters path)))))

                 :on-change (make-on-change-handler opts)
                 :class []}
          (seq @form-errors)
          (update :class conj "form-item__checkbox--error")

          css-class-prefix
          (update :class conj (str css-class-prefix "__checkbox")))]
       (when (or label-transl-kw label) [label-with-tooltip
                                         component-id
                                         label-transl-kw
                                         label
                                         info-tooltip-transl-kw
                                         css-class-prefix disabled?
                                         mandatory? form-errors])
       (when (seq @form-errors)
         [form.error/form-item-errors @form-errors])])))
